import Vue from 'vue'
import Vuex from 'vuex'
import o from '@/odata'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
var userInfoString = window.localStorage.getItem('CURRENT_USER')
var userInfo = {}
if (userInfoString) {
  userInfo = JSON.parse(userInfoString)
}
const state = {
  currentCostomer: userInfo.customer || {},
  userInfo: userInfo,
  leasePriceParams: {
    word: null,
    modelId: null,
  },
  trustListPageTarget: null,  // 跳转到委托库查询的目标flag：all 为委托总库，self 为自己委托库
}

const actions = {
  GET_CURRENT_COSTOMER({ commit }) {
    o('Partner/Services.GetCurrentCustomer()').get().then(({ data }) => {
      commit('GET_CURRENT_COSTOMER', data)
    })
  },
  // 设置委托库查询跳转flag
  SET_TRUST_LIST_PAGE_TARGET({ commit }, data) {
    commit('SET_TRUST_LIST_PAGE_TARGET', data)
  },
  SET_LEASE_PRICE_PARAMS({ commit }, data) {
    commit('SET_LEASE_PRICE_PARAMS', data)
  },
  // 清除委托库查询跳转flag
  CLEAN_TRUST_LIST_PAGE_TARGET({ commit }, data) {
    commit('CLEAN_TRUST_LIST_PAGE_TARGET', data)
  },
  CLEAR_LEASE_PRICE_PARAMS({ commit }) {
    commit('CLEAR_LEASE_PRICE_PARAMS')
  },
}

const mutations = {
  GET_CURRENT_COSTOMER(store, currentCostomer) {
    Object.assign(store, { currentCostomer })
  },
  SET_TRUST_LIST_PAGE_TARGET(store, trustListPageTarget) {
    store.trustListPageTarget = trustListPageTarget
  },
  SET_LEASE_PRICE_PARAMS(store, leasePriceParams) {
    store.leasePriceParams = leasePriceParams
  },
  CLEAN_TRUST_LIST_PAGE_TARGET(store) {
    store.trustListPageTarget = null
  },
  CLEAR_LEASE_PRICE_PARAMS(store) {
    store.leasePriceParams = null
  },
}

export default new Vuex.Store({
  strict: debug,
  state,
  actions,
  mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js